export type GuideTourFeatureFlagSignal = 'allowed' | 'blocked' | 'pending'

let guideTourFeatureFlagOnReader:
  | ((flagName: string) => boolean | undefined)
  | null = null

const resolvedGuideTourFeatureFlagCache = new Map<
  string,
  Exclude<GuideTourFeatureFlagSignal, 'pending'>
>()

const clearGuideTourFeatureFlagCache = (): void => {
  resolvedGuideTourFeatureFlagCache.clear()
}

export const setGuideTourFeatureFlagOn = (
  reader: ((flagName: string) => boolean | undefined) | null
): void => {
  guideTourFeatureFlagOnReader = reader
  clearGuideTourFeatureFlagCache()
}

const getGuideTourFeatureFlagOn = ():
  | ((flagName: string) => boolean | undefined)
  | undefined => guideTourFeatureFlagOnReader ?? undefined

export const hasGuideTourFeatureFlagCallback = (): boolean =>
  getGuideTourFeatureFlagOn() !== undefined

export const resolveGuideTourFeatureFlagSignal = (
  flagName: string
): GuideTourFeatureFlagSignal => {
  const cached = resolvedGuideTourFeatureFlagCache.get(flagName)
  if (cached !== undefined) {
    return cached
  }

  const query = getGuideTourFeatureFlagOn()
  if (!query) {
    return 'blocked'
  }

  const result = query(flagName)

  if (result === undefined) {
    return 'pending'
  }

  const signal: Exclude<GuideTourFeatureFlagSignal, 'pending'> = result
    ? 'allowed'
    : 'blocked'
  resolvedGuideTourFeatureFlagCache.set(flagName, signal)
  return signal
}

/** `true` only when the host callback resolved the flag as on. */
export const isGuideTourFeatureFlagOn = (flagName: string): boolean =>
  resolveGuideTourFeatureFlagSignal(flagName) === 'allowed'
